import { useRegisterSW } from 'virtual:pwa-register/react'
import { Snackbar, Alert, Button } from '@mui/material'

/**
 * Surfaces the two states vite-plugin-pwa's autoUpdate service worker can't
 * signal on its own: content now cached for offline use, and a new version
 * waiting to take over (needs a reload to activate).
 */
const PWAUpdatePrompt = () => {
  const {
    offlineReady: [offlineReady, setOfflineReady],
    needRefresh: [needRefresh, setNeedRefresh],
    updateServiceWorker,
  } = useRegisterSW()

  const close = () => {
    setOfflineReady(false)
    setNeedRefresh(false)
  }

  return (
    <>
      <Snackbar open={offlineReady} autoHideDuration={4000} onClose={close}>
        <Alert onClose={close} severity="success" variant="filled">
          Smart Nyuki is ready to work offline
        </Alert>
      </Snackbar>
      <Snackbar open={needRefresh} onClose={close}>
        <Alert
          onClose={close}
          severity="info"
          variant="filled"
          action={
            <Button
              color="inherit"
              size="small"
              onClick={() => updateServiceWorker(true)}
            >
              Reload
            </Button>
          }
        >
          A new version is available
        </Alert>
      </Snackbar>
    </>
  )
}

export default PWAUpdatePrompt
